import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Input,
  Label,
  Button,
  FormGroup,
} from "reactstrap";

import swal from "sweetalert";
import { useNavigate } from "react-router-dom";

import {
    _Get,
  _GetByUrlOnly,
  CreateCustomersave,
  Get_RoleList,
} from "../../ApiEndPoint/ApiCalling";

import { GST_Verification_Api, viewpincodedata1 } from "../../ApiEndPoint/Api";
import axiosConfig from "../../AxiosConfig"
export default function CreateCustomer() {
  const navigate = useNavigate();

  // ✅ FORM STATE
  const [formData, setFormData] = useState({
    CompanyName: "",
    mobileNumber: "",
    aadharNo: "",
    partyType: "",
    registrationType: "",
    gstNumber: "",
    comPanNo: "",
    address: "",
    email: "",
    password: "",
    dealsInProducts: "",
    annualTurnover: "",
    paymentTerm: "",
    pincode: "",
    City: "",
    State: "",

    // ✅ OPENING BALANCE
    OpeningBalance: "",
    Type: "",

    // ✅ ROLE
    roleName: "Customer",
    rolename: "",

    // ✅ BANK DETAILS
    bankDetails: [
      {
        Account_Name: "",
        Account_No: "",
        Ifsc_code: "",
      },
    ],
  });

  const [cityOptions, setCityOptions] = useState([]);
  const [showCityDropdown, setShowCityDropdown] = useState(false);
const [Loader, setLoader] = useState(false);
  const [Image, setImage] = useState(null);
  const [PhotoImage, setPhotoImage] = useState([]);

  // =====================================================
  // ✅ GET CUSTOMER ROLE
  // =====================================================

  useEffect(() => {
    getCustomerRole();
  }, []);

  const getCustomerRole = async () => {
    try {
      const userdata = JSON.parse(localStorage.getItem("userData"));

      const res = await Get_RoleList(
        userdata?._id,
        userdata?.database
      );
      const showList = res?.Role?.filter((item) =>
        item?.roleName?.toLowerCase()?.includes("customer")
      );

      if (showList?.length > 0) {
        setFormData((prev) => ({
          ...prev,
          rolename: showList[0]?._id,
          roleName: showList[0]?.roleName,
        }));
      }
    } catch (err) {
      console.log(err);
      swal("Roles List Not Found");
    }
  };

  // =====================================================
  // ✅ HANDLE CHANGE
  // =====================================================

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // ✅ PINCODE API
    if (name === "pincode" && value.length === 6) {
      fetchData(value);
    }
  };

  // =====================================================
  // ✅ BANK CHANGE
  // =====================================================

  const handleBankChange = (index, e) => {
    const { name, value } = e.target;

    const updatedBank = [...formData.bankDetails];

    updatedBank[index][name] = value;

    setFormData((prev) => ({
      ...prev,
      bankDetails: updatedBank,
    }));
  };

  // =====================================================
  // ✅ ADD BANK
  // =====================================================

  const addBank = () => {
    setFormData((prev) => ({
      ...prev,
      bankDetails: [
        ...prev.bankDetails,
        {
          Account_Name: "",
          Account_No: "",
          Ifsc_code: "",
        },
      ],
    }));
  };

  // =====================================================
  // ✅ PINCODE API
  // =====================================================

  const fetchData = async (pincode) => {
    try {
      const res = await _GetByUrlOnly(
        `${viewpincodedata1}?pincode=${pincode}`
      );

      // ✅ SINGLE CITY
      if (res?.pinCodes?.length === 1) {
        const data = res.pinCodes[0];

        setShowCityDropdown(false);
        setCityOptions([]);

        setFormData((prev) => ({
          ...prev,
          pincode,
          City: data.city || "",
          State: data.state || "",
        }));
      }

      // ✅ MULTIPLE CITY
      else if (res?.pinCodes?.length > 1) {
        setShowCityDropdown(true);

        setCityOptions(
          res.pinCodes.map((item) => ({
            label: item.city,
            value: item.city,
            state: item.state,
          }))
        );

        setFormData((prev) => ({
          ...prev,
          pincode,
          City: "",
          State: res.pinCodes[0]?.state || "",
        }));
      }

      // ✅ NO DATA
      else {
        setShowCityDropdown(false);
        setCityOptions([]);

        setFormData((prev) => ({
          ...prev,
          City: "",
          State: "",
        }));
      }
    } catch (err) {
      console.log("Pincode Error", err);
    }
  };

  // =====================================================
  // ✅ SUBMIT
  // =====================================================

  const submitHandler = async (e) => {
    e.preventDefault();

    try {
      const userData = JSON.parse(
        localStorage.getItem("userData")
      );

      // ✅ VALIDATION

      if (!formData.CompanyName) {
        return swal("Company Name Required");
      }

      if (!formData.mobileNumber) {
        return swal("Mobile Number Required");
      }

      if (!formData.email) {
        return swal("Email Required");
      }

      if (!formData.password) {
        return swal("Password Required");
      }

      if (!formData.OpeningBalance) {
        return swal("Opening Balance Required");
      }

      if (!formData.Type) {
        return swal("Balance Type Required");
      }

      const formdata = new FormData();

      // ✅ FINAL PAYLOAD
      const payload = {
        ...formData,

        id: formData.comPanNo || formData.aadharNo,

        created_by: userData?._id,

        database: userData?.database,

        rolename: formData?.rolename,

        roleName: formData?.roleName,

        // ✅ IMPORTANT
        OpeningBalance: Number(
          formData.OpeningBalance || 0
        ),

        annualTurnover: Number(
          formData.annualTurnover || 0
        ),
      };

      // ✅ APPEND ALL DATA
      Object.entries(payload).forEach(([key, value]) => {
        if (value === undefined || value === null) return;

        // ARRAY / OBJECT
        if (
          Array.isArray(value) ||
          typeof value === "object"
        ) {
          formdata.append(key, JSON.stringify(value));
        } else {
          formdata.append(key, value);
        }
      });

      // ✅ SINGLE FILE
      if (Image) {
        formdata.append("file", Image);
      }

      // ✅ MULTIPLE FILES
      if (PhotoImage?.length > 0) {
        PhotoImage.forEach((img) => {
          formdata.append("files", img);
        });
      }

      // ✅ DEBUG
      console.log("========= FINAL PAYLOAD =========");

      for (let pair of formdata.entries()) {
        console.log(pair[0], pair[1]);
      }
      // ✅ API CALL
      const res = await CreateCustomersave(formdata);

      if (res?.status) {
        swal(
          "Success",
          "Customer Created Successfully",
          "success"
        );

        navigate(-1);
      } else {
        swal(
          "Error",
          res?.message || "Something Went Wrong"
        );
      }
    } catch (err) {
      console.log("ERROR =>", err?.response?.data);

      swal(
        "Error",
        err?.response?.data?.message ||
          "Something Went Wrong",
        "error"
      );
    }
  };

  return (
    <div className="container-fluid mt-3">
      <Card
        style={{
          borderRadius: "12px",
          background: "#f4f6fb",
          border: "1px solid #ddd",
        }}
      >
        <CardBody>
          <h2 className="text-center mb-4">
            Company Information
          </h2>

          <form onSubmit={submitHandler}>
            <Row>
              {/* COMPANY NAME */}
              <Col md="6" className="mb-3">
                <Label>Company Name *</Label>

                <Input
                  name="CompanyName"
                  value={formData.CompanyName}
                  onChange={handleChange}
                  placeholder="Enter Company Name"
                />
              </Col>

              {/* MOBILE */}
              <Col md="6" className="mb-3">
                <Label>Mobile Number *</Label>

                <Input
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  placeholder="Enter Mobile Number"
                />
              </Col>

              {/* AADHAR */}
              <Col md="6" className="mb-3">
                <Label>Aadhar Number *</Label>

                <Input
                  name="aadharNo"
                  value={formData.aadharNo}
                  onChange={handleChange}
                  placeholder="Enter Aadhar Number"
                />
              </Col>

              {/* PARTY TYPE */}
              <Col md="6" className="mb-3">
                <Label>Party Type</Label>

                <Input
                  type="select"
                  name="partyType"
                  value={formData.partyType}
                  onChange={handleChange}
                >
                  <option value="">--Select--</option>

                  <option value="Debitor">
                    Debitor
                  </option>

                  <option value="Creditor">
                    Creditor
                  </option>

                  <option value="eCommerce">
                    E-Commerce
                  </option>
                </Input>
              </Col>

              {/* REGISTRATION TYPE */}
              {/* <Col md="6" className="mb-3">
                <Label>Registration Type</Label>

                <Input
                  type="select"
                  name="registrationType"
                  value={formData.registrationType}
                  onChange={handleChange}
                >
                  <option value="">--Select--</option>

                  <option value="Regular">
                    Regular
                  </option>

                  <option value="UnRegister">
                    UnRegister
                  </option>

                  <option value="UnKnown">
                    UnKnown
                  </option>
                </Input>
              </Col>

          
              <Col md="6" className="mb-3">
                <Label>GST Number</Label>

                <Input
                  name="gstNumber"
                  value={formData.gstNumber}
                  onChange={handleChange}
                  placeholder="Enter GST Number"
                />
              </Col>

            
              <Col md="6" className="mb-3">
                <Label>PAN Number</Label>

                <Input
                  name="comPanNo"
                  value={formData.comPanNo}
                  onChange={handleChange}
                  placeholder="Enter PAN Number"
                />
              </Col> */}
{/* REGISTRATION TYPE */}
<Col lg="6" md="6" sm="12">
  <FormGroup>
    <Label>Registration Type</Label>

    <Input
      type="select"
      name="registrationType"
      value={formData?.registrationType}
      onChange={handleChange}
    >
      <option value="">--Select--</option>

      <option value="UnKnown">
        UnKnown
      </option>

      <option value="Regular">
        Regular
      </option>

      <option value="UnRegister">
        UnRegister
      </option>
    </Input>
  </FormGroup>
</Col>

{/* GST + PAN */}
{formData?.registrationType !== "UnKnown" && (
  <>

    {/* GST NUMBER */}
    {formData?.registrationType !== "UnRegister" && (
      <Col lg="6" md="6" sm="12">

        <Label>
          GST Number
          <span style={{ color: "red" }}>
            {" "}*
          </span>
        </Label>

        <Input
          type="text"
          name="gstNumber"
          minLength={15}
          maxLength={15}
          placeholder="Enter GST Number"
          value={formData?.gstNumber}
          onChange={async (e) => {

            let value =
              e.target.value.toUpperCase();

            setFormData((prev) => ({
              ...prev,
              gstNumber: value,
            }));

            // GST VERIFY
            if (value.length === 15) {

              try {

                setLoader(true);

                const res = await axiosConfig.get(
                  "http://sheet.gstincheck.co.in/check/5649422e1a7c37dadb607c7cc5882693/",
                  value
                );
                const parts =
                  res?.data?.pradr?.adr?.split(",") || [];

                const part1 =
                  parts[0]?.trim() || "";

                const part2 =
                  parts.slice(1).join(",").trim();

                if (res?.flag) {

                  setFormData((prev) => ({
                    ...prev,

                    CompanyName:
                      res?.data?.tradeNam || "",

                    address:
                      `${part1} ${part2}`,

                    gstNumber: value,

                    comPanNo:
                      value?.slice(2, 12),
                  }));

                }

                setLoader(false);

              } catch (err) {

                console.log(err);

                setLoader(false);

                setFormData((prev) => ({
                  ...prev,
                  gstNumber: value,
                  comPanNo: value?.slice(2, 12),
                }));
              }
            }
          }}
        />

        {Loader && (
          <div style={{ color: "red" }}>
            Getting GST Information...
          </div>
        )}

      </Col>
    )}

    {/* PAN NUMBER */}
    <Col lg="6" md="6" sm="12">

      <FormGroup>

        <Label>
          PAN Number
          <span style={{ color: "red" }}>
            {" "}*
          </span>
        </Label>

        <Input
          type="text"
          name="comPanNo"
          minLength={10}
          maxLength={10}
          placeholder="Enter PAN Number"
          value={formData?.comPanNo}
          onChange={(e) => {

            const inputPan =
              e.target.value.toUpperCase();

            setFormData((prev) => ({
              ...prev,
              comPanNo: inputPan,
            }));
          }}
        />

        {formData?.comPanNo?.length > 0 &&
          formData?.comPanNo?.length < 10 && (
            <span style={{ color: "red" }}>
              Enter Correct PAN Number
            </span>
          )}

      </FormGroup>

    </Col>

  </>
)}
              {/* ADDRESS */}
              <Col md="6" className="mb-3">
                <Label>Address</Label>

                <Input
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Enter Address"
                />
              </Col>

              {/* EMAIL */}
              <Col md="6" className="mb-3">
                <Label>Email</Label>

                <Input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter Email"
                />
              </Col>

              {/* PASSWORD */}
              <Col md="6" className="mb-3">
                <Label>Password</Label>

                <Input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter Password"
                />
              </Col>

              {/* DEALS */}
              <Col md="6" className="mb-3">
                <Label>Deals In Products</Label>

                <Input
                  name="dealsInProducts"
                  value={formData.dealsInProducts}
                  onChange={handleChange}
                  placeholder="Deals In Products"
                />
              </Col>

              {/* TURNOVER */}
              <Col md="6" className="mb-3">
                <Label>Annual Turnover</Label>

                <Input
                  type="number"
                  name="annualTurnover"
                  value={formData.annualTurnover}
                  onChange={handleChange}
                  placeholder="Annual Turnover"
                />
              </Col>

              {/* OPENING BALANCE */}
              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <Label>Opening Balance</Label>

                  <Input
                    type="number"
                    name="OpeningBalance"
                    value={formData.OpeningBalance}
                    onChange={handleChange}
                    placeholder="Opening Balance"
                  />
                </FormGroup>
              </Col>

              {/* TYPE */}
              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <Label>O/P Balance Type</Label>

                  <Input
                    type="select"
                    name="Type"
                    value={formData.Type}
                    onChange={handleChange}
                  >
                    <option value="">
                      ----select Type----
                    </option>

                    <option value="debit">
                      Dr
                    </option>

                    <option value="credit">
                      Cr
                    </option>
                  </Input>
                </FormGroup>
              </Col>

              {/* PAYMENT TERM */}
              <Col md="6" className="mb-3">
                <Label>Payment Term</Label>

                <Input
                  type="select"
                  name="paymentTerm"
                  value={formData.paymentTerm}
                  onChange={handleChange}
                >
                  <option value="">Select</option>

                  <option value="Cash">
                    Cash
                  </option>

                  <option value="Credit">
                    Credit
                  </option>
                </Input>
              </Col>

              {/* PINCODE */}
              <Col md="6" className="mb-3">
                <Label>Pincode</Label>

                <Input
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  placeholder="Enter Pincode"
                />
              </Col>

              {/* CITY */}
              <Col md="6" className="mb-3">
                <Label>City</Label>

                {showCityDropdown ? (
                  <Input
                    type="select"
                    name="City"
                    value={formData.City}
                    onChange={(e) => {
                      const selected =
                        cityOptions.find(
                          (c) =>
                            c.value ===
                            e.target.value
                        );

                      setFormData((prev) => ({
                        ...prev,
                        City: selected?.value || "",
                        State:
                          selected?.state || "",
                      }));
                    }}
                  >
                    <option value="">
                      Select City
                    </option>

                    {cityOptions.map((c, i) => (
                      <option
                        key={i}
                        value={c.value}
                      >
                        {c.label}
                      </option>
                    ))}
                  </Input>
                ) : (
                  <Input
                    value={formData.City || ""}
                    readOnly
                  />
                )}
              </Col>

              {/* STATE */}
              <Col md="6" className="mb-3">
                <Label>State</Label>

                <Input
                  value={formData.State || ""}
                  readOnly
                />
              </Col>

              {/* BANK DETAILS */}
              <Col md="12">
                <h5 className="mt-3 mb-3">
                  Bank Details
                </h5>
              </Col>

              {formData.bankDetails.map(
                (bank, index) => (
                  <React.Fragment key={index}>
                    <Col md="4" className="mb-3">
                      <Label>
                        Account Name
                      </Label>

                      <Input
                        name="Account_Name"
                        value={
                          bank.Account_Name || ""
                        }
                        onChange={(e) =>
                          handleBankChange(
                            index,
                            e
                          )
                        }
                      />
                    </Col>

                    <Col md="4" className="mb-3">
                      <Label>
                        Account Number
                      </Label>

                      <Input
                        name="Account_No"
                        value={
                          bank.Account_No || ""
                        }
                        onChange={(e) =>
                          handleBankChange(
                            index,
                            e
                          )
                        }
                      />
                    </Col>

                    <Col md="4" className="mb-3">
                      <Label>IFSC Code</Label>

                      <Input
                        name="Ifsc_code"
                        value={
                          bank.Ifsc_code || ""
                        }
                        onChange={(e) =>
                          handleBankChange(
                            index,
                            e
                          )
                        }
                      />
                    </Col>
                  </React.Fragment>
                )
              )}

              {/* ADD BANK */}
              <Col md="12" className="mb-3">
                <Button
                  type="button"
                  color="success"
                  onClick={addBank}
                >
                  Add Another Bank
                </Button>
              </Col>

              {/* PAN IMAGE */}
              <Col md="6" className="mb-3">
                <Label>PAN Card Image</Label>

                <Input
                  type="file"
                  onChange={(e) =>
                    setImage(
                      e.target.files[0]
                    )
                  }
                />
              </Col>

              {/* SHOP PHOTOS */}
              <Col md="6" className="mb-3">
                <Label>Shop Photos</Label>

                <Input
                  type="file"
                  multiple
                  onChange={(e) =>
                    setPhotoImage([
                      ...e.target.files,
                    ])
                  }
                />
              </Col>
            </Row>

            {/* SAVE BUTTON */}
            <div className="text-center mt-4">
              <Button
                color="primary"
                size="lg"
                type="submit"
              >
                Save Customer
              </Button>
            </div>
          </form>
        </CardBody>
      </Card>
    </div>
  );
}